import { render } from "./SpeakerIcon.vue?vue&type=template&id=dd4f33d4"
import script from "./SpeakerIcon.vue?vue&type=script&lang=js"
export * from "./SpeakerIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__